<template>
    <div class="authenticename">
        <div id="IDCertify"></div>
        <veui-form
            ref="form"
            :data="formData"
            class="authentice-name-form"
        >
            <veui-field
                name="checked"
                field="checked"
                class="agree"
            >
                <veui-checkbox
                    v-model="formData.checked"
                    :false-value="null"
                >
                    我已阅读并同意:
                </veui-checkbox>
                <span class="rule" @click.stop="goto">《百度个人实名认证规则说明》</span>
                <div v-if="error" class="veui-field-error">请勾选阅读协议</div>
            </veui-field>
        </veui-form>
    </div>
</template>

<script>
/**
 * @file index.vue
 * @author baoleilei
 * @desc 我的资料-个人认证
 */
/* global passport */
import {Checkbox, Form, Field} from 'veui';
export default {
    name: 'authentice-name',
    components: {
        'veui-checkbox': Checkbox,
        'veui-form': Form,
        'veui-field': Field
    },
    data() {
        return {
            formData: {
                checked: null
            },
            error: false
        };
    },
    methods: {
        goto() {
            window.open('https://lvlin.baidu.com/pc/static/tob-certification');
        }
    },
    mounted() {
        let that = this;
        this.$nextTick(function () {
            window.passport.use('IDCertify', {
                tangram: true,
                defaultCss: true
            }, function (magic) {
                let IDCertify = new magic.passport.IDCertify({
                    product: 'lvlin',
                    u: window.location.protocol + '//passport.baidu.com/passApi/html/success.html',
                    safeFlag: 0,
                    defaultCss: true,
                    staticPage: window.location.protocol + '//passport.baidu.com/passApi/html/jump.html'
                });

                IDCertify.on('submitSuccess', function (e) {
                    // 阻止默认跳转事件
                    that.$emit('update:firmLawyerCurrent', 2);
                    that.$emit('changeCurrentIndex', 2);
                    that.$emit('update:current', 2);
                    that.$emit('getData');
                    e.returnValue = false;
                });

                IDCertify.on('renderFinish', function () {
                    console.log('renderFinish');
                });

                IDCertify.on('beforeSubmit', function (e) {
                    /* eslint-disable max-nested-callbacks */
                    if (that.formData.checked) {
                        that.error = false;
                        // e.returnValue = true;
                    }
                    else {
                        that.error = true;
                        e.returnValue = false;
                    }
                });

                IDCertify.render('IDCertify');

            });
        });
    }
};
</script>

<style lang="less">
#IDCertify {
    /deep/ .pass-button-submit {
        margin-top: 60px;
    }
}
.authenticename {
    position: relative;
    .authentice-name-form {
        position: relative;
    }
    .agree {
        position: absolute;
        margin-left: 0;
    }
    .rule {
        color: #0052CC;
    }
    /deep/ .veui-field-error {
        color: #fc4343;
        font-size: 12px;
    }
}

</style>